module.exports = __webpack_public_path__ + "static/media/ShipPendingTask.aa78c235.svg";